"use client";

import React, { createContext, useContext, ReactNode } from 'react';

const PaymentContext = createContext<any>(undefined);

export default function PaymentProvider({ children }: { children: ReactNode }) {
  return (
    <PaymentContext.Provider value={{}}>
      {children}
    </PaymentContext.Provider>
  );
}

export function usePayment() {
  const context = useContext(PaymentContext);
  if (context === undefined) {
    return {};
  }
  return context;
}
